<section class="options-dropdown_section">
  <div class="options-dropdown__container">
    <div aria-label="Timeline grouping table" class="table">
      <p class="timeframe-dropdown__heading">{{ 'group_by' | ppTranslate }}</p>

      @for (option of options; track option.value) {
        <li class="siteOptionsTable__item" (click)="setGrouping(option)">
          <pp-radio [ppChecked]="selectedOption === option.value" ppStyle="blue">
            <p class="siteOptionsTable__columnName">
              {{ option.name }}
            </p>
          </pp-radio>
        </li>
      }
    </div>
  </div>
</section>
